import { createAction } from "typesafe-actions";
import { IGrainProfileExtended, IGrainProfileMapping } from "../../models";

export const setProfileId = createAction('SET_PROFILE_ID')<string>();

export const setGrainProfiles = createAction('SET_GRAIN_PROFILES')<IGrainProfileExtended[]>();

export const setSelectedGrainProfileMapping = createAction('SET_SELECTED_GRAIN_PROFILE_MAPPING')<IGrainProfileMapping>();

export const setBrokenParam = createAction('SET_BROKEN_PARAM')<number>();

export const setBrokenByShape = createAction('SET_BROKEN_BY_SHAPE')<boolean>();

export const reset = createAction('RESET')<void>();
